function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { Pill } from 'module-tsl-ui-elements';

var ElementsSubTopics = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementsSubTopics, _React$Component);

  var _super = _createSuper(ElementsSubTopics);

  function ElementsSubTopics(props) {
    var _this;

    _classCallCheck(this, ElementsSubTopics);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickHandler", function (subTopicId, activeSubTopics) {
      var currentUrl = window.location.href;

      var newSubtopics = _this.getNewSubTopics(subTopicId, activeSubTopics);

      var urlWithoutPages = _this.getNewUrl(currentUrl, 'page', '');

      var newUrl = _this.getNewUrl(urlWithoutPages, 'subtopics', newSubtopics.join());

      window.location.replace(newUrl);
    });

    _defineProperty(_assertThisInitialized(_this), "getNewUrl", function (currentUrl, key, newSubtopics) {
      var newSubtopicsString = !newSubtopics ? '' : "&".concat(key, "=").concat(newSubtopics);
      return currentUrl.replace(new RegExp("([?&]".concat(key, "(?=[=&#]|$)[^#&]*|(?=#|$))")), newSubtopicsString).replace(/^([^?&]+)&/, '$1?');
    });

    _defineProperty(_assertThisInitialized(_this), "getNewSubTopics", function (subTopicId, activeSubTopics) {
      return includes(activeSubTopics, subTopicId) ? activeSubTopics.filter(function (currentSubTopic) {
        return currentSubTopic !== subTopicId;
      }) : [].concat(_toConsumableArray(activeSubTopics), [subTopicId]);
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", function (subTopicId, activeSubTopics) {
      return includes(activeSubTopics, subTopicId) ? 'pill pill--elements pill--active' : 'pill pill--elements';
    });

    _this.state = {};
    return _this;
  }

  _createClass(ElementsSubTopics, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          subTopics = _this$props.subTopics,
          activeSubTopics = _this$props.activeSubTopics;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: "list-inline margin-top-ml"
      }, subTopics.map(function (_ref) {
        var id = _ref.id,
            text = _ref.text;
        return /*#__PURE__*/React.createElement("li", {
          className: "margin-bottom-sm"
        }, /*#__PURE__*/React.createElement(Pill, {
          theme: "white",
          className: _this2.getClassName(id, activeSubTopics),
          onClick: function onClick() {
            return _this2.onClickHandler(id, activeSubTopics);
          }
        }, text));
      })));
    }
  }]);

  return ElementsSubTopics;
}(React.Component);

ElementsSubTopics.displayName = "ElementsSubTopics";
ElementsSubTopics.propTypes = {
  subTopics: PropTypes.array,
  activeSubTopics: PropTypes.array
};
export default ElementsSubTopics;